<template>
  <div class="instagram-user">
    <DefImg v-if="result.pictures.avatar" :result="result.pictures.avatar" max-width="48px" />

    <div class="instagram-user__description">
      <a :href="result.instagramLink" class="instagram-user__name" target="_blank">{{
        result.instagramName
      }}</a>
      <span class="instagram-user__likes">
        <svg class="instagram-user__favourite"><use xlink:href="#svg-like"></use></svg>
        {{ result.likesQuantity }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import DefImg from '@components/Def/DefImg/DefImg.vue';

const props = defineProps(['result']);
</script>

<style lang="scss" scoped>
.instagram-user {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  grid-column-gap: 16px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  padding: 8px;
  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    @include point-md {
      font-size: 18px;
    }
  }
  &__likes {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
    @include point-md {
      font-size: 16px;
    }
  }
  &__favourite {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
  &__description {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
  }
}
</style>
